import PropTypes from 'prop-types';
import { Box, IconButton, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

MainTabs.propTypes = {
    tabs: PropTypes.array,
    activeRoute: PropTypes.string,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
};

export default function MainTabs({ tabs, activeRoute, onChange, onClose }) {
    if (!tabs.length) {
        return null;
    }

    return (
        <Box
            sx={{
                flexShrink: 0,
                borderBottom: '1px solid',
                borderColor: '#d0dce8',
                bgcolor: '#f1f5f9',
                px: 0.5,
                pt: 0.5,
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Tabs
                value={activeRoute || false}
                onChange={(event, route) => onChange(route)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    minHeight: 34,
                    width: 1,
                    '& .MuiTabs-indicator': {
                        display: 'none',
                    },
                    '& .MuiTabs-flexContainer': {
                        gap: '4px',
                        alignItems: 'flex-end',
                    },
                    '& .MuiTab-root': {
                        minWidth: 'auto',
                        minHeight: 30,
                        px: 1.2,
                        py: 0.25,
                        marginRight: '0px !important',
                        '&:not(:last-of-type)': {
                            marginRight: '0px !important',
                        },
                        textTransform: 'none',
                        color: '#1a4f8b',
                        fontWeight: 400,
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px',
                        border: '1px solid #d4e2ee',
                        borderBottom: 'none',
                        bgcolor: '#e2ebf5',
                        transition: 'all 0.15s ease-in-out',
                        '&:hover': {
                            bgcolor: '#d7e4f1',
                        },
                    },
                    '& .MuiTab-root.Mui-selected': {
                        color: '#002e6e',
                        fontWeight: 700,
                        bgcolor: '#ffffff',
                        borderColor: '#c9d9e8',
                        borderBottom: '1px solid #ffffff',
                        marginBottom: '-1px',
                        zIndex: 1,
                    },
                }}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.route}
                        value={tab.route}
                        label={(
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, maxWidth: 200 }}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    noWrap
                                    sx={{
                                        fontSize: '0.8125rem',
                                        fontWeight: 'inherit',
                                        color: 'inherit',
                                        maxWidth: 150,
                                    }}
                                >
                                    {tab.label}
                                </Typography>
                                <Tooltip title="Close">
                                    <IconButton
                                        component="span"
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onClose(tab.route);
                                        }}
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            p: 0,
                                            color: 'inherit',
                                            opacity: 0.75,
                                            borderRadius: '4px',
                                            '&:hover': {
                                                opacity: 1,
                                                bgcolor: 'rgba(0, 0, 0, 0.08)',
                                            },
                                            '& svg': { fontSize: 13 },
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        )}
                    />
                ))}
            </Tabs>
        </Box>
    );
}
